import MeetingDetailsComponent from "./TableComponents/CustomComponents/MeetingDetailsComponent";
const OrganizationDetailsFormFields = [
  {
    componentType: "text",
    label: "Organization name",
    id: "Organisation_organisation_name",
    required: true,
    pinCondition: "left",
  },
  {
    componentType: "dropdown",
    label: "Level structure",
    id: "Organisation_level_structure",
    optionsKey: "level_structures",
  },
  {
    componentType: "dropdown",
    label: "Ownership",
    id: "Organisation_ownership",
    addNewOption: true,
    optionsKey: "ownerships",
    dropDown: "Ownership",
    field_name: "ownership",
  },
  {
    componentType: "multiSelect",
    id: "Organisation_individual_type",
    required: true,
    optionsKey: "individual_types",
    label: "Organizational type",
    addNewOption: true,
    dropDown: "IndividualType",
    field_name: "individual_type",
  },
  {
    componentType: "text",
    label: "Background/Overview",
    id: "Organisation_background",
  },
  {
    componentType: "multiSelect",
    label: "Type of contract",
    id: "Organisation_type_of_contract",
    optionsKey: "fully_managed_services",
    addNewOption: true,
    dropDown: "FullyManagedService",
    field_name: "name",
  },
  {
    componentType: "multiSelect",
    label: "Contract category",
    id: "Organisation_contract_category",
    optionsKey: "adhocs",
    addNewOption: true,
    dropDown: "Adhoc",
    field_name: "name",
  },
  {
    componentType: "multiSelect",
    label: "Service",
    id: "Organisation_service",
    optionsKey: "service_types",
  },
  {
    componentType: "multiSelect",
    label: "Service type",
    id: "Organisation_type_of_services",
    optionsKey: "type_of_services",
    addNewOption: true,
    dropDown: "TypeOfService",
    field_name: "type_of_service",
  },
  {
    componentType: "multiSelect",
    label: "Services offered",
    id: "Organisation_services_offered",
    disabled: true,
  },
  {
    componentType: "dropdown_predictive",
    label: "Internal status",
    id: "Organisation_internal_status",
    required: true,
    optionsKey: "internal_statuses",
    addNewOption: true,
    dropDown: "InternalStatus",
    field_name: "internal_status",
  },
  {
    componentType: "dropdown",
    label: "aimio target company",
    id: "Organisation_aimio_target_company",
    optionsKey: "yes_or_no",
  },
  {
    componentType: "dropdown",
    id: "Organisation_aimio_user",
    label: "aimio user",
    optionsKey: "yes_or_no",
  },
  {
    componentType: "dropdown",
    label: "MOE target company",
    id: "Organisation_moe_target_company",
    optionsKey: "yes_or_no",
  },
  {
    componentType: "dropdown",
    label: "MOE user",
    id: "Organisation_moe_user",
    optionsKey: "yes_or_no",
  },
  {
    componentType: "dropdown_predictive",
    label: "Territory",
    id: "Organisation_territory",
    required: true,
    optionsKey: "territories",
    addNewOption: true,
    dropDown: "Territory",
    field_name: "territory",
  },
  {
    componentType: "multiSelect",
    label: "Industry sector",
    id: "Organisation_industry_sector",
    required: true,
    optionsKey: "industry_sector_lists",
    addNewOption: true,
    dropDown: "IndustrySectorList",
    field_name: "industry_sector",
  },
  {
    componentType: "dropdown_predictive",
    label: "Source type",
    id: "Organisation_source_type",
    optionsKey: "source_referral1s",
    addNewOption: true,
    required: true,
    dropDown: "SourceReferral1",
    field_name: "referral1",
  },
  {
    componentType: "multiSelect",
    label: "Source company",
    id: "Organisation_source_company",
    optionsKey: "source_referral2s",
    required: true,
    addNewOption: true,
    dropDown: "SourceReferral2",
    field_name: "referral2",
  },
  {
    componentType: "dropdown_predictive",
    label: "Source person",
    id: "Organisation_source_person",
    optionsKey: "source_referral3s",
    required: true,
    addNewOption: true,
    dropDown: "SourceReferral3",
    field_name: "referral3",
  },
  {
    componentType: "datePicker",
    required: true,
    label: "Date source received",
    id: "Organisation_date_source_received",
    futureDateHide: true,
    enableColumnFilter: false,
    enableGlobalFilter: false,
  },
  {
    componentType: "datePicker",
    label: "Attended Acuity event/s",
    id: "Organisation_attended_acuity_event_date",
    enableColumnFilter: false,
    enableGlobalFilter: false,
  },
  {
    componentType: "text",
    label: "Acuity event",
    id: "Organisation_acuity_event",
  },
  {
    componentType: "dropdown",
    label: "Panel",
    id: "Organisation_panel",
    optionsKey: "yes_or_no",
  },
  // {
  //   componentType: "uploadFiles",
  //   label: "Organization picture",
  //   id: "Organisation_organization_picture",
  //   enableColumnFilter: false,
  //   enableGlobalFilter: false,
  //   enableSorting: false,
  // },
  {
    componentType: "multiSelect",
    label: "Acuity account director",
    id: "Organisation_acuity_account_director",
    optionsKey: "acuity_account_directors",
  },
  {
    componentType: "multiSelect",
    label: "Acuity account manager",
    id: "Organisation_acuity_account_manager",
    // value: account_manager_id,
    optionsKey: "account_managers",
  },
  {
    componentType: "multiSelect",
    label: "Acuity coaching coordinator",
    id: "Organisation_acuity_coaching_coordinator",

    optionsKey: "coaching_coordinators",
  },
  {
    componentType: "dropdown_predictive",
    label: "Client account management",
    id: "Organisation_client_account_management",
    optionsKey: "client_account_managements",
    addNewOption: true,
    dropDown: "ClientAccountManagement",
    field_name: "client_account_management",
  },
  {
    componentType: "uploadFiles",
    label: "Meeting/Call documents",
    id: "OrganisationBusinessDevelopment_meeting_call_documents",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  // {
  //   componentType: "customComponent",
  //   id: "Organisation_meeting_or_Call_dates",
  //   label: "Meeting/Call dates",
  //   customComponentProps: {
  //     componentObject: [
  //       {
  //         componentType: "datePicker",
  //         type: "text",
  //         label: "Meeting date",
  //         name: "Organisation_meeting_or_Call_dates_meeting_datetime",
  //       },
  //       {
  //         componentType: "timeComponent",
  //         type: "text",
  //         label: "Meeting start time",
  //         name: "Organisation_meeting_or_Call_dates_start_time",
  //       },
  //       {
  //         componentType: "timeComponent",
  //         type: "text",
  //         label: "Meeting end time",
  //         name: "Organisation_meeting_or_Call_dates_end_time",
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Description of call",
  //         name: "Organisation_meeting_or_Call_dates_description",
  //         placeholder: "Description of call",
  //         multiline: true,
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Who involved in meeting",
  //         name: "Organisation_meeting_or_Call_dates_who_involved",
  //         placeholder: "Who involved in meeting",
  //         multiline: true,
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Prep required",
  //         name: "Organisation_meeting_or_Call_dates_prep_required",
  //         placeholder: "Prep required",
  //         multiline: true,
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Temporary owner",
  //         name: "Organisation_meeting_or_Call_dates_temporary_owner",
  //         placeholder: "Temporary owner",
  //         multiline: true,
  //       },
  //       {
  //         componentType: "select",
  //         label: "Platform",
  //         name: "Organisation_meeting_or_Call_dates_platform",
  //         placeholder: "Platform",
  //         optionsKey: "platforms",
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Briefing",
  //         name: "Organisation_meeting_or_Call_dates_briefing",
  //         placeholder: "Briefing",
  //         multiline: true,
  //       },
  //     ],
  //   },
  //   customComponentKey: "meetingDetails",
  // },
  //   {
  //     componentType: "rederComponent",
  //     name: "Organisation_client_action_list",
  //     value: client_action_lists,
  //     component: (
  //       <ClientActionListComponent
  //         handleChange={handleInputChange}
  //         name="client_action_lists"
  //         value={client_action_lists}
  //         label="Client action list"
  //         componentObject={[
  //           {
  //             componentType: "datePicker",
  //             type: "text",
  //             label: "Date received",
  //             name: "date_received",
  //           },
  //           {
  //             componentType: "select",
  //             label: "Priority",
  //             name: "priority_id",
  //             placeholder: "Priority",
  //             selectOptions: priorities,
  //             handleChange: handleInputChange,
  //           },
  //           {
  //             componentType: "select",
  //             label: "Status",
  //             name: "status",
  //             placeholder: "Status",
  //             selectOptions: status,
  //             handleChange: handleInputChange,
  //           },
  //           {
  //             componentType: "SelectSpecific",
  //             label: "Area",
  //             id: "org_area_id",
  //             name: "org_area_id",
  //             placeholder: "Area",
  //             isChild: true,
  //             selectOptions: org_areas,
  //             handleChange: handleInputChange,
  //             dropDown: "OrgArea",
  //             field_name: "name",
  //           },
  //           {
  //             componentType: "input",
  //             type: "text",
  //             label: "Description",
  //             name: "description",
  //             placeholder: "Description",
  //             multiline: true,
  //           },
  //           {
  //             componentType: "input",
  //             type: "text",
  //             label: "Stakeholder/s",
  //             name: "stakeholders",
  //             placeholder: "Stakeholders",
  //             multiline: true,
  //           },
  //           {
  //             componentType: "multiSelectChip",
  //             label: "Who by",
  //             name: "who_by",
  //             id: "who_by",
  //             placeholder: "Who by",
  //             itemArr: who_by,
  //             isChild: true,
  //           },
  //           {
  //             componentType: "datePicker",
  //             type: "text",
  //             label: "Deadline date",
  //             name: "deadline_date",
  //           },
  //           {
  //             componentType: "datePicker",
  //             type: "text",
  //             label: "Completed date",
  //             name: "completed_date",
  //           },
  //         ]}
  //       />
  //     ),
  //   },
];

const OrganizationProfilesFormFields = [
  {
    componentType: "multiSelect",
    label: "Account director",
    id: "OrganisationProfile_account_director",
    optionsKey: "employees",
  },
  {
    componentType: "text",
    label: "Market cap (if listed)",
    id: "OrganisationProfile_market_cap",
  },
  {
    componentType: "dropdown_predictive",
    label: "Market cap currency",
    id: "OrganisationProfile_market_currency",
    optionsKey: "currencies",
  },
  {
    componentType: "text",
    label: "Company news",
    required: true,
    id: "OrganisationProfile_company_news",
  },
  {
    componentType: "text",

    label: "Company registration number",
    id: "OrganisationProfile_company_registration_number",
    required: true,
  },
  // {
  //   componentType: "dropdown",
  //   label: "Criteria",
  //   id: "OrganisationProfile_criteria",
  //   optionsKey: "criterias",
  // },

  {
    componentType: "dropdown",
    label: "Opportunities",
    id: "OrganisationProfile_opportunities",
    optionsKey: "opportunities",
  },
  {
    componentType: "dropdown",
    label: "Priority criteria",
    id: "OrganisationProfile_priority_criteria",
    optionsKey: "priority_criterias",
  },
  {
    componentType: "dropdown_predictive",
    label: "Decision maker based",
    id: "OrganisationProfile_decision_maker_basis_in",
    optionsKey: "country_lists",
  },
  {
    componentType: "dropdown_predictive",
    label: "High growth sector",
    id: "OrganisationProfile_high_growth_sector",
    optionsKey: "high_growth_sectors",
    dropDown: "HighGrowthSector",
    field_name: "high_growth_sector",
    addNewOption: true,
  },
  {
    componentType: "dropdown_predictive",
    label: "500+ knowledge workers",
    id: "OrganisationProfile_knowledge_workers_500",
    optionsKey: "knowledge_workers",
    dropDown: "KnowledgeWorker",
    addNewOption: true,
    field_name: "knowledge_worker",
  },
  {
    componentType: "dropdown_predictive",
    label: "Global or International",
    id: "OrganisationProfile_global_or_international",
    optionsKey: "globals",
    dropDown: "Global",
    field_name: "value",
    addNewOption: true,
  },
  {
    componentType: "dropdown_predictive",
    label: "Wealth mindset",
    id: "OrganisationProfile_wealth_mindset",
    optionsKey: "wealth_mindsets",
    dropDown: "WealthMindset",
    field_name: "wealth_mindset",
  },
  {
    componentType: "text",
    label: "Recognized brand",
    id: "OrganisationProfile_recognised_brand",
  },
  {
    componentType: "text",
    label: "Engaged and committed stakeholder",
    id: "OrganisationProfile_engaged_stackholder",
  },
  {
    componentType: "text",

    label: "Multiple service line opportunity",
    id: "OrganisationProfile_multiple_service_line_opportunity",
  },
  {
    componentType: "text",
    label: "Master vendor opportunity",
    id: "OrganisationProfile_master_vendor_opportunity",
  },
  {
    componentType: "dropdown_predictive",
    label: "Centralised HR",
    id: "OrganisationProfile_centralised_HR",
    optionsKey: "centralised_hrs",
    dropDown: "CentralisedHr",
    field_name: "centralised_hr",
    addNewOption: true,
  },
  {
    componentType: "multiSelect",
    label: "Key stakeholders based in",
    id: "OrganisationProfile_key_stakeholders_based_in",
    optionsKey: "key_stakeholders_based_in",
  },
  {
    componentType: "multiSelect",
    label: "Key stakeholders",
    id: "OrganisationProfile_key_stakeholders",
    optionsKey: "employees",
    // doubt employees or stakeholder
  },

  {
    componentType: "text",
    label: "Names of people who have main access",
    id: "OrganisationProfile_main_access_people_names",
  },
  {
    componentType: "multiSelect",
    label: "Delivery locations",
    id: "OrganisationProfile_delivery_locations",
    optionsKey: "country_lists",
  },

  {
    componentType: "dropdown_predictive",
    label: "Number of employees",
    id: "OrganisationProfile_number_of_employees",
    optionsKey: "number_of_employees",
  },
  {
    componentType: "uploadFiles",
    id: "OrganisationProfile_general_documentation",
    label: "General documentation",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "uploadFiles",
    id: "OrganisationProfile_accounts_upload",
    label: "Accounts upload",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "text",
    label: "Accounts contact name",
    id: "OrganisationProfile_account_contact",
    required: true,
  },
  {
    componentType: "text",
    label: "Accounts email",
    id: "OrganisationProfile_account_email",
    required: true,
    validationType: "email",
  },
  {
    componentType: "text",
    label: "Account telephone",
    id: "OrganisationProfile_account_telephone",
    validationType: "number",
  },
  {
    componentType: "text",
    label: "Internal notes",
    id: "OrganisationProfile_internal_note",
  },
];

const OrganizationContactFormFields = [
  {
    componentType: "text",
    label: "Website",
    id: "OrganisationContactInfo_website",
    required: true,
  },
  {
    componentType: "text",
    id: "OrganisationContactInfo_HQ_address",
    label: "HQ address",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "customComponent",
    id: "OrganisationContactInfo_org_address",
    label: "Business address",
    customComponentKey: "orgAddress",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "text",
    id: "OrganisationContactInfo_business_telephone",
    label: "Business telephone",
    validationType: "number",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "text",
    id: "OrganisationContactInfo_business_fax",
    label: "Business fax",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "text",
    id: "OrganisationContactInfo_business_email",
    label: "Business email",
    validationType: "email",
  },
  {
    componentType: "text",
    label: "Primary email",
    id: "OrganisationContactInfo_primary_email",
    validationType: "email",
  },
  {
    componentType: "text",
    label: "Primary telephone",
    id: "OrganisationContactInfo_primary_telephone",
    validationType: "number",
  },
  {
    componentType: "text",
    label: "Facebook",
    id: "OrganisationContactInfo_facebook",
  },
  {
    componentType: "text",
    label: "LinkedIn",
    id: "OrganisationContactInfo_linkedin",
  },
  {
    componentType: "text",
    label: "Twitter",
    id: "OrganisationContactInfo_twitter",
  },
  {
    componentType: "text",
    label: "Parent organization",
    id: "OrganisationContactInfo_parent_organisation",
  },
  {
    componentType: "customComponent",
    customComponentKey: "magicFields",
    label: "Terminology used",
    id: "OrganisationContactInfo_terminology",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  // {
  //   componentType: "rederComponent",
  //   value: magic20_fields,
  //   component: (
  //     <IncomePerYearComponent
  //       handleChange={handleInputChange}
  //       value={magic20_fields}
  //     />
  //   ),
  // },
];

const OrganizationBusinessDevelopmentFields = [
  // {
  //   componentType: "rederComponent",
  //   name: "meeting_details",
  //   value: meetingDetails,
  //   label: "Meeting/Call dates",
  //   component: <InitialCallMeeting
  //     handleChange={handleInputChange}
  //     name="meeting_details"
  //     value={meetingDetails}
  //     label="Meeting/Call dates"
  //     componentObject={
  //       [
  //         {
  //           componentType: "datePicker",
  //           type: "text",
  //           label: "Meeting date",
  //           name: "meeting_datetime",
  //         },
  //         {
  //           componentType: "timeComponent",
  //           type: "text",
  //           label: "Meeting start time",
  //           name: "start_time",
  //         },
  //         {
  //           componentType: "timeComponent",
  //           type: "text",
  //           label: "Meeting end time",
  //           name: "end_time",
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Description of call",
  //           name: "description",
  //           placeholder: "Description of call",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Who involved in meeting",
  //           name: "who_involved",
  //           placeholder: "Who involved in meeting",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Prep required",
  //           name: "prep_required",
  //           placeholder: "Prep required",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Temporary owner",
  //           name: "temporary_owner",
  //           placeholder: "Temporary owner",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "select",
  //           label: "Platform",
  //           name: "platform",
  //           placeholder: "Platform",
  //           selectOptions: platforms,
  //           handleChange: handleInputChange,
  //         }
  //         , {
  //           componentType: "input",
  //           type: "text",
  //           label: "Briefing",
  //           name: "briefing",
  //           placeholder: "Briefing",
  //           multiline: true
  //         },
  //       ]}
  //   />
  // },
  // {
  //   componentType: "rederComponent",
  //   name: "task_lists",
  //   value: taskDetails,
  //   component: <InitialCallTask
  //     handleChange={handleInputChange}
  //     name="task_lists"
  //     value={taskDetails}
  //     label="Task list"
  //     componentObject={[
  //       {
  //         componentType: "datePicker",
  //         type: "text",
  //         label: "Date received",
  //         name: "date_received",
  //       }, {
  //         componentType: "select",
  //         label: "Priority",
  //         name: "priority_id",
  //         placeholder: "Priority",
  //         selectOptions: priorities,
  //         handleChange: handleInputChange,
  //       },
  //       {
  //         componentType: "SelectSpecific",
  //         label: "Area",
  //         name: "org_area_id",
  //         id: "org_area_id",
  //         placeholder: "Area",
  //         selectOptions: org_areas,
  //         handleChange: handleInputChange,
  //         dropDown: "OrgArea",
  //         field_name: "name",
  //         isChild: true,
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Description",
  //         name: "description",
  //         placeholder: "Description",
  //         multiline: true,
  //       },
  //       {
  //         componentType: "input",
  //         type: "text",
  //         label: "Stakeholder/s",
  //         name: "stakeholders",
  //         placeholder: "Stakeholders",
  //         multiline: true,
  //       },
  //       {
  //         componentType: "multiSelectChip",
  //         label: "Who by",
  //         name: "who_by",
  //         id: "who_by",
  //         placeholder: "who by",
  //         itemArr: who_by,
  //         isChild: true
  //       },
  //       {
  //         componentType: "datePicker",
  //         type: "text",
  //         label: "Deadline date",
  //         name: "deadline_date",
  //       },
  //       {
  //         componentType: "datePicker",
  //         type: "text",
  //         label: "Completed date",
  //         name: "completed_date",
  //       },
  //     ]}
  //   />
  // },
  {
    componentType: "datePicker",
    label: "Date project received",
    id: "OrganisationBusinessDevelopment_date_project_received",
  },

  {
    componentType: "dropdown_predictive",
    label: "BD status",
    id: "OrganisationBusinessDevelopment_bd_status",
    optionsKey: "bd_statuses",
    addNewOption: true,
    dropDown: "BdStatus",
    field_name: "status",
  },
  {
    componentType: "text",
    label: "Initial activity",
    id: "OrganisationBusinessDevelopment_initial_activity",
  },
  {
    componentType: "dropdown_predictive",
    label: "Type of work",
    id: "OrganisationBusinessDevelopment_type_of_work",
    optionsKey: "type_of_works",
    addNewOption: true,
    dropDown: "TypeOfWork",
    field_name: "type_of_work",
  },
  {
    componentType: "dropdown",
    label: "Transcription",
    id: "OrganisationBusinessDevelopment_transcription",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "uploadFiles",
    id: "OrganisationBusinessDevelopment_transcription_document",
    label: "Transcription documents",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "text",
    label: "Thank you note",
    id: "OrganisationBusinessDevelopment_thank_you_note",
  },
  {
    componentType: "datePicker",
    label: "Follow up date",
    id: "OrganisationBusinessDevelopment_follow_up_date",
  },
  {
    componentType: "dropdown",
    label: "Urgent",
    id: "OrganisationBusinessDevelopment_urgent",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "text",
    label: "Next steps",
    id: "OrganisationBusinessDevelopment_next_step",
  },
  {
    componentType: "text",
    label: "Actions to complete",
    id: "OrganisationBusinessDevelopment_task_list",
  },
  {
    componentType: "text",
    label: "History/Comments",
    id: "OrganisationBusinessDevelopment_history",
  },
  {
    componentType: "datePicker",
    label: "CAM call date",
    id: "OrganisationBusinessDevelopment_cam_call_date",
  },
  {
    componentType: "dropdown_predictive",
    label: "CAM status",
    id: "OrganisationBusinessDevelopment_cam_status",
    optionsKey: "cam_statuses",
    dropDown: "CamStatus",
    field_name: "cam_status",
    addNewOption: true,
  },

  {
    label: "Meeting/Call documents",
    componentType: "uploadFiles",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    id: "OrganisationBusinessDevelopment_meeting_call_documents",
    enableSorting: false,
  },
];

const organizationScopingPhaseFormFields = [
  {
    componentType: "text",
    label: "Scoping",
    id: "OrganisationPreContract_scoping",
  },
  {
    componentType: "uploadFiles",
    label: "Proposals",
    id: "OrganisationPreContract_proposals",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "uploadFiles",
    label: "Presentations",
    id: "OrganisationPreContract_presentations",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "uploadFiles",
    label: "Commercial (Global Rate Card, Including Programmes) ",
    id: "OrganisationPreContract_commercial_global_rate",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "uploadFiles",
    label: "RFI",
    id: "OrganisationPreContract_rfi",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },

  {
    componentType: "multiSelect",
    label: "Client checklist",
    id: "OrganisationPreContract_client_checklist",
    optionsKey: "client_checklists",
    dropDown: "ClientChecklist",
    field_name: "name",
    addNewOption: true,
  },

  {
    componentType: "text",
    label: "Internal notes",
    required: true,
    id: "OrganisationPreContract_internal_notes",
  },
];

const organizationContractFormFields = [
  {
    componentType: "datePicker",
    required: true,
    label: "Start date with client activity",
    id: "OrganisationContractPhase_start_date_with_client",
  },
  {
    componentType: "text",
    label: "Time from start date",
    id: "OrganisationContractPhase_time_from_start_date",
    disabled: true,
  },
  // {
  //   componentType: "rederComponent",
  //   name: "fiscal_year",
  //   value: fiscal_year,
  //   component: <FiscalYearComponent
  //     handleChange={handleInputChange}
  //     name="fiscal_year"
  //     value={fiscal_year}
  //   />
  // },
  {
    componentType: "fiscalYear",
    label: "Fiscal year",
    id: "OrganisationContractPhase_fiscal_year",
    enableColumnFilter: false,
    enableSorting: false,
    enableGlobalFilter: false,
  },
  {
    // not coming
    componentType: "text",
    label: "Time to contract expiry date",
    id: "OrganisationContractPhase_time_to_end_date",
    disabled: true,
  },
  {
    componentType: "datePicker",
    required: true,
    label: "Account closed date",
    id: "OrganisationContractPhase_date_account_closed",
  },
  {
    componentType: "text",
    label: "Total time start to account closed date",
    id: "OrganisationContractPhase_total_time_start_to_account_closed_date",
    disabled: true,
  },
  {
    componentType: "uploadFiles",
    id: "OrganisationContractPhase_legal_contract",
    label: "Legal contract - working version",
    enableColumnFilter: false,
    enableSorting: false,
    enableGlobalFilter: false,
  },

  {
    componentType: "dropdown",
    label: "Variation agreement",
    id: "OrganisationContractPhase_variation_agreement",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "dropdown",
    label: "NDA required",
    id: "OrganisationContractPhase_NDA",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "dropdown",
    label: "PES required",
    id: "OrganisationContractPhase_PES_required",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "dropdown",
    label: "SLA",
    id: "OrganisationContractPhase_SLA",
    optionsKey: "only_yes_or_no",
  },

  {
    componentType: "uploadFiles",
    id: "OrganisationContractPhase_legal_contract_variation",
    label:
      "Legal contract, variation agreement, NDA and associated documentation - final versions",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  {
    componentType: "dropdown",
    label: "Legal contract - final",
    id: "OrganisationContractPhase_legal_contract_final",
    optionsKey: "only_yes_or_no",
  },
  {
    // not coming
    componentType: "dropdown",
    label: "Contract rolling",
    id: "OrganisationContractPhase_contract_rolling",
    optionsKey: "only_yes_or_no",
  },
  {
    // not coming

    componentType: "text",
    label: "Legal contract review notes",
    id: "OrganisationContractPhase_legal_contract_review_notes",
  },
  {
    componentType: "datePicker",
    // required: true,
    label: "Legal contract start date",
    id: "OrganisationContractPhase_legal_contract_start_date",
  },
  {
    componentType: "datePicker",
    // required: true,
    label: "Legal contract expiry date",
    id: "OrganisationContractPhase_legal_contract_expiry_date",
  },
  {
    componentType: "text",
    label: "Financial invoice status",
    id: "OrganisationContractPhase_financial_invoice_status",
  },
  {
    componentType: "datePicker",
    required: true,
    label: "Date of first revenue",
    id: "OrganisationContractPhase_date_of_first_revenue",
  },
  {
    componentType: "datePicker",
    required: true,
    label: "Date of most recent revenue",
    id: "OrganisationContractPhase_date_of_most_recent_revenue",
  },
  {
    componentType: "text",
    label: "Lifetime income from client",
    id: "OrganisationContractPhase_lifetime_income_from_client",
  },
  // {
  //   componentType: "rederComponent",
  //   name: "incomes",
  //   value: incomes,
  //   component: <IncomePerYearComponent
  //     handleChange={handleInputChange}
  //     name="incomes"
  //     value={incomes}
  //     componentObject={[
  //       {
  //         componentType: "inputWithDropdown",
  //         type: "number",
  //         inputName: "income",
  //         selectName: "currency_id",
  //         inputPlaceholder: "$00,000,000",
  //         selectPlaceholder: "USD",
  //         apiVariable: "currencies",
  //         selectOptions: currencies,
  //         selectWithAutoComplete: true
  //       },
  //     ]}
  //   />
  // },
  // {
  //   componentType: "inputWithDropdown",
  //   label: "Revenue currency",
  //   type: "number",
  //   inputName: "revenue",
  //   selectName: "revenue_currency_id",
  //   inputPlaceholder: "$00,000,000",
  //   selectPlaceholder: "USD",
  //   selectOptions: currencies,
  //   handleInputChange: handleInputChange,
  //   handleSelectChange: handleInputChange,
  //   inputValue: revenue,
  //   selectValue: revenue_currency_id,
  //   selectWithAutoComplete: true
  // },
  {
    componentType: "customComponent",
    id: "OrganisationContractPhase_income_per_year",
    label: "Income per year",
    customComponentKey: "incomePerYear",
    customComponentProps: {},
  },
  {
    componentType: "text",
    label: "Revenue",
    id: "OrganisationContractPhase_revenue",
  },
  {
    componentType: "dropdown",
    label: "Revenue currency",
    id: "OrganisationContractPhase_revenue_currency",
    optionsKey: "currencies",
  },
  {
    componentType: "text",
    label: "Admin time/month",
    multiline: true,
    id: "OrganisationContractPhase_admin_time",
  },
];

const organizationReportingFormFields = [
  {
    componentType: "text",
    label: "Acuity objective for this organisation",
    id: "OrganisationActivityField_acuity_objective",
    multiline: true,
  },
  {
    componentType: "text",
    label: "Internal notes",
    id: "OrganisationActivityField_internal_notes",
  },

  {
    componentType: "text",
    label: "Current area being reviewed",
    id: "OrganisationActivityField_current_area_being_reviewed",
  },
  {
    componentType: "dropdown",
    label: "MI required",
    id: "OrganisationActivityField_mi_required",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "multiSelect",
    label: "Reports",
    id: "OrganisationActivityField_reports",
    optionsKey: "formsSelector",
    addNewOption: true,
    dropDown: "Form",
    field_name: "name",
  },
  {
    componentType: "dropdown",
    label: "Review required",
    id: "OrganisationActivityField_review",
    optionsKey: "only_yes_or_no",
  },
  {
    componentType: "multiSelect",
    label: "Review reports required",
    id: "OrganisationActivityField_review_reports_required",
    optionsKey: "review_reports",
    itemArr: "reviewReportSelector",
    addNewOption: true,
    dropDown: "ReviewReport",
    field_name: "name",
  },
  {
    componentType: "dropdown_predictive",
    label: "Review frequency",
    id: "OrganisationActivityField_review_frequency",
    optionsKey: "review_frequency",
    addNewOption: true,
    dropDown: "ReviewFrequency",
    field_name: "name",
  },
  // {
  //   componentType: "datePicker",
  //   required: true,
  //   label: "Review dates*",
  //   id: "review_dates",
  //   value: review_dates,
  //   plusIcon: "yes",
  //   getAllValue: true,
  //   placeholder: "DD/MM/YYYY",
  //   helperText: errors.review_dates && "Please select a date",
  //   handleChange: handleInputChange,
  // },
  {
    componentType: "text",
    label: "Next review agenda",
    id: "OrganisationActivityField_next_review_agenda",
  },
  {
    label: "Meeting/Call documents",
    componentType: "uploadFiles",
    id: "OrganisationActivityField_meeting_or_call_documents",
    enableColumnFilter: false,
    enableGlobalFilter: false,
    enableSorting: false,
  },
  // {
  //   componentType: "rederComponent",
  //   name: "meeting_details",
  //   value: meeting_details,
  //   component: (
  //     <MeetingDetailsComponent
  //       handleChange={handleInputChange}
  //       name="meeting_details"
  //       value={meeting_details}
  //       label="Meeting/Call dates"
  //       componentObject={[
  //         {
  //           componentType: "datePicker",
  //           type: "text",
  //           label: "Meeting date and time",
  //           name: "meeting_datetime",
  //         },
  //         {
  //           componentType: "timeComponent",
  //           type: "text",
  //           label: "Meeting start time",
  //           name: "start_time",
  //         },
  //         {
  //           componentType: "timeComponent",
  //           type: "text",
  //           label: "Meeting end time",
  //           name: "end_time",
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Description of call",
  //           name: "description",
  //           placeholder: "Description of call",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Who involved in meeting",
  //           name: "who_involved",
  //           placeholder: "Who involved in meeting",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Prep required",
  //           name: "prep_required",
  //           placeholder: "Prep required",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Temporary owner",
  //           name: "temporary_owner",
  //           placeholder: "Temporary owner",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "select",
  //           label: "Platform",
  //           name: "platform",
  //           placeholder: "Platform",
  //           selectOptions: platforms,
  //           handleChange: handleInputChange,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Briefing",
  //           name: "briefing",
  //           placeholder: "Briefing",
  //           multiline: true,
  //         },
  //       ]}
  //     />
  //   ),
  // },
  // {
  //   componentType: "rederComponent",
  //   name: "client_action_lists",
  //   value: client_action_lists,
  //   component: (
  //     <ClientActionListComponent
  //       handleChange={handleInputChange}
  //       name="client_action_lists"
  //       value={client_action_lists}
  //       label="Client action list"
  //       componentObject={[
  //         {
  //           componentType: "datePicker",
  //           type: "text",
  //           label: "Date received",
  //           name: "date_received",
  //         },
  //         {
  //           componentType: "select",
  //           label: "Priority",
  //           name: "priority_id",
  //           placeholder: "Priority",
  //           selectOptions: priorities,
  //           handleChange: handleInputChange,
  //         },
  //         {
  //           componentType: "select",
  //           label: "Status",
  //           name: "status",
  //           placeholder: "Status",
  //           selectOptions: status,
  //           handleChange: handleInputChange,
  //         },
  //         {
  //           componentType: "SelectSpecific",
  //           label: "Area",
  //           name: "org_area_id",
  //           id: "org_area_id",
  //           placeholder: "Area",
  //           selectOptions: org_areas,
  //           handleChange: handleInputChange,
  //           dropDown: "OrgArea",
  //           field_name: "name",
  //           isChild: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Description",
  //           name: "description",
  //           placeholder: "Description",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "input",
  //           type: "text",
  //           label: "Stakeholder/s",
  //           name: "stakeholders",
  //           placeholder: "Stakeholders",
  //           multiline: true,
  //         },
  //         {
  //           componentType: "multiSelectChip",
  //           label: "Who by",
  //           name: "who_by",
  //           id: "who_by",
  //           placeholder: "who by",
  //           itemArr: who_by,
  //           isChild: true,
  //         },
  //         {
  //           componentType: "datePicker",
  //           type: "text",
  //           label: "Deadline date",
  //           name: "deadline_date",
  //         },
  //         {
  //           componentType: "datePicker",
  //           type: "text",
  //           label: "Completed date",
  //           name: "completed_date",
  //         },
  //       ]}
  //     />
  //   ),
  // },
];
const organizationGeneralFormFields = [
  {
    componentType: "dropdown_predictive",
    label: "Record owner",
    id: "OrganisationGeneralDetail_record_owner",
    optionsKey: "record_owners",
    addNewOption: true,
    dropDown: "RecordOwner",
    field_name: "record_owner",
  },
  {
    componentType: "text",
    label: "Admin access",
    multiline: true,
    id: "OrganisationGeneralDetail_has_admin_access",
  },

  {
    componentType: "text",
    label: "Total no of assignments",
    id: "OrganisationGeneralDetail_total_no_of_assignments",
    disabled: true,
  },
  {
    componentType: "dropdown_predictive",
    label: "Information",
    id: "OrganisationGeneralDetail_information",
    optionsKey: "list_of_assignments",
    addNewOption: true,
    dropDown: "ListOfAssignment",
    field_name: "value",
  },

  {
    componentType: "dropdown_predictive",
    label: "Number of assignments",
    id: "OrganisationGeneralDetail_number_of_assignments",
    optionsKey: "number_of_assignments",
    addNewOption: true,
    dropDown: "NumberOfAssignment",
    field_name: "number_of_assignment",
  },
  // {
  //   componentType: "rederComponent",
  //   component: (
  //     <CustomClientPanelArea
  //       label="Client panel area"
  //       data={client_panel_areas}
  //     />
  //   ),
  // },
];

export const orgGroupedColumns = [
  {
    id: "organization_details",
    groupName: "Organization details",
    columns: OrganizationDetailsFormFields,
  },
  {
    id: "organization_profile",
    groupName: "Profile",
    columns: OrganizationProfilesFormFields,
  },
  {
    id: "organization_contact",
    groupName: "Contact",
    columns: OrganizationContactFormFields,
  },
  {
    id: "organization_business_development",
    groupName: "Business Development",
    columns: OrganizationBusinessDevelopmentFields,
  },
  {
    id: "organization_scoping_phase",
    groupName: "Scoping Phase",
    columns: organizationScopingPhaseFormFields,
  },
  {
    id: "organization_contract",
    groupName: "Contract",
    columns: organizationContractFormFields,
  },
  {
    id: "organization_reporting",
    groupName: "Reporting and Review",
    columns: organizationReportingFormFields,
  },
  {
    id: "organization_general",
    groupName: "General",
    columns: organizationGeneralFormFields,
  },
];
